// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "rdkbuiltins/v1/rdkbuiltins.proto" (package "rdkbuiltins.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Service to provide information about published versions of viam-server
//
// This service is meant to be a non-permanent solution to support procedurally
// generated FE config builder fancy cards
//
// Some people think it would be ideal if this information lived in the registry
// and rdk builtins were treated as modules however, we have not yet solved the
// attribute-schema design problem and so are forced to work around it with apis
// like this.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RdkBuiltinsService } from "./rdkbuiltins";
import type { GetAttributeSchemaResponse } from "./rdkbuiltins";
import type { GetAttributeSchemaRequest } from "./rdkbuiltins";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetRegistrationsResponse } from "./rdkbuiltins";
import type { GetRegistrationsRequest } from "./rdkbuiltins";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rdkbuiltins.v1.RdkBuiltinsService
 */
export interface IRdkBuiltinsServiceClient {
    /**
     * @generated from protobuf rpc: GetRegistrations(rdkbuiltins.v1.GetRegistrationsRequest) returns (rdkbuiltins.v1.GetRegistrationsResponse);
     */
    getRegistrations(input: GetRegistrationsRequest, options?: RpcOptions): UnaryCall<GetRegistrationsRequest, GetRegistrationsResponse>;
    /**
     * @generated from protobuf rpc: GetAttributeSchema(rdkbuiltins.v1.GetAttributeSchemaRequest) returns (rdkbuiltins.v1.GetAttributeSchemaResponse);
     */
    getAttributeSchema(input: GetAttributeSchemaRequest, options?: RpcOptions): UnaryCall<GetAttributeSchemaRequest, GetAttributeSchemaResponse>;
}
/**
 * @generated from protobuf service rdkbuiltins.v1.RdkBuiltinsService
 */
export class RdkBuiltinsServiceClient implements IRdkBuiltinsServiceClient, ServiceInfo {
    typeName = RdkBuiltinsService.typeName;
    methods = RdkBuiltinsService.methods;
    options = RdkBuiltinsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetRegistrations(rdkbuiltins.v1.GetRegistrationsRequest) returns (rdkbuiltins.v1.GetRegistrationsResponse);
     */
    getRegistrations(input: GetRegistrationsRequest, options?: RpcOptions): UnaryCall<GetRegistrationsRequest, GetRegistrationsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRegistrationsRequest, GetRegistrationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAttributeSchema(rdkbuiltins.v1.GetAttributeSchemaRequest) returns (rdkbuiltins.v1.GetAttributeSchemaResponse);
     */
    getAttributeSchema(input: GetAttributeSchemaRequest, options?: RpcOptions): UnaryCall<GetAttributeSchemaRequest, GetAttributeSchemaResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAttributeSchemaRequest, GetAttributeSchemaResponse>("unary", this._transport, method, opt, input);
    }
}
